import _ from "lodash";
import { FolderStructure, FolderItemType } from "../Primitive/TreeStructure";
// ------------------------------------------------------------------------------------------------------
function cleanEmptyFolders(folders: FolderStructure[]): FolderStructure[] {
    // Go to the children and do the same !!!
    for (var f of folders)
        if (f.type == FolderItemType.Folder)
            f.children = cleanEmptyFolders(f.children);

    // Now that we go to the depth of folders start delete empty folders
    _.remove(folders, x => (x.type == FolderItemType.Folder) && (x.children == null || x.children.length == 0));
    return folders;
}
// ------------------------------------------------------------------------------------------------------
export function buildStructureFromPath(arr: FolderStructure[]): FolderStructure[] {
    var tree: FolderStructure[] = [];

    // First map the nodes of the array to an object -> create a hash table.
    var mappedArr = _.keyBy(arr, "_id");

    // Reset children element
    _.forOwn(mappedArr, (v, k) => v.children = []);

    // Mapped the elements
    _.forOwn(mappedArr, (v, k) => {
        // If the element is not at the root level, add it to its parent array of children.
        if (v.parentId) {
            mappedArr[v.parentId].children.push(v);
        }
        // If the element is at the root level, add it to first level elements array.
        else {
            tree.push(v);
        }
    });

    return cleanEmptyFolders(tree);
}
// ------------------------------------------------------------------------------------------------------